import * as keys from '../actions/user';
import Vue from 'vue';
import { ALERT_APPEND } from '../actions/alerts'

const state = {
	user: {
		username: '',
		roles: []
	},
	isAuthenticated: false
}

const getters = {}

const mutations = {
	[keys.USER_LOGIN]: (state, user) => {
		Vue.set(state, 'user', user);
		state.isAuthenticated = true;
	},

	[keys.USER_LOGOUT]: (state) => {
		Vue.set(state, 'user', { username: '', roles: [] });
		state.isAuthenticated = false;
	},
}

const actions = {
	[keys.USER_GET]: async ({ commit }) => {
		return await Vue.axios.get('/session-user')
			.then(response => {
				commit(keys.USER_LOGIN, response.data);

				return response;
			})
			.catch(error => {
				commit(keys.USER_LOGOUT);

				return error.response;
			})
		;
	},

	[keys.USER_LOGIN]: async ({ commit, dispatch }, creds) => {
		return await Vue.axios.post('/login', creds)
			.then(response => {
				commit(keys.USER_LOGIN, response.data);

				return response;
			})
			.catch(error => {
				dispatch(ALERT_APPEND, error.response.data.error);
				return error.response;
			})
		;
	},

	[keys.USER_LOGOUT]: async ({ commit }) => {
		return await Vue.axios.get('/logout')
			.then(response => {
				commit(keys.USER_LOGOUT);

				return response;
			})
			.catch(error => {
				commit(keys.USER_LOGOUT);

				return error.response;
			})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
